import { FormikValues } from 'formik';
import moment from 'moment';

import { IAddTask, IEditTask } from '../../../services/tasks';
import { IDictionaryItem } from '../../../state/app/dictionaries';
import { isUnassigned } from '../../../state/ui/planning/tasks/utils/isUnassigned';
import { getAttributesPayload } from '../../Attributes/utils';

export const getTypesIds = (
    activityCategory: number,
    serviceType: IDictionaryItem[],
    objectCategory: IDictionaryItem[]
) => {
    const uniqueMatch = (items: IDictionaryItem[]) =>
        items.filter((item) => item.parentId === activityCategory);

    const serviceTypeMatches = uniqueMatch(serviceType);
    const objectCategoryMatches = uniqueMatch(objectCategory);

    const serviceTypeId: number | '' =
        serviceTypeMatches.length === 1 ? serviceTypeMatches[0].id : '';
    const objectCategoryId: number | '' =
        objectCategoryMatches.length === 1 ? objectCategoryMatches[0].id : '';

    return { serviceTypeId, objectCategoryId };
};

export const createTaskForm = (task: IAddTask | IEditTask, files: File[]) => {
    if (task.serviceClassId === -1) {
        task.serviceClassId = undefined;
    }
    const form = new FormData();
    form.append(
        'task',
        new Blob([JSON.stringify(task)], { type: 'application/json' })
    );
    for (const file of files) {
        form.append('files', file);
    }
    return form;
};

export const prepareTask = (values: FormikValues, attributes: FormikValues) => {
    const {
        status,
        objectCategory,
        activityCategory,
        serviceType,
        serviceClass,
        notice,
        noDate,
        plannedOn,
        employee,
        vehicle,
        location,
        unitsCount,
        externalLinkages,
        plannedTimeFrom,
        plannedTimeTo,
        route,
        rfidCode,
    } = values;

    return {
        status: status as number,
        objectCategoryId: objectCategory as number,
        activityCategoryId: activityCategory as number,
        serviceTypeId: serviceType as number,
        serviceClassId: serviceClass as number,
        notice: notice as string,
        plannedOn: noDate ? undefined : (plannedOn as string),
        employeeId: employee && (employee.id as number),
        vehicleId: vehicle && (vehicle.id as number),
        locationId: location && location.id,
        unitsCount: unitsCount || 0,
        externalLinkages: externalLinkages,
        plannedTimeFrom: plannedTimeFrom
            ? moment(plannedTimeFrom).format('HH:mm')
            : undefined,
        plannedTimeTo: plannedTimeTo
            ? moment(plannedTimeTo).format('HH:mm')
            : undefined,
        routeId: isUnassigned(route?.id) ? undefined : route.id,
        attributes: getAttributesPayload(attributes),
        rfidCode: rfidCode,
    };
};
